/* global store */
import { collapseIframe } from 'Renderer/domOperations/iFrameOperations';

const setWallpaperSpacing = (value) => {
  const { rootBodyElement } = store.getState(); // eslint-disable-line no-undef
  const spacingProperty = rootBodyElement.getAttribute('data-ivo-spacing') || 'marginTop';
  if (spacingProperty === 'none') return;
  rootBodyElement.style[spacingProperty] = `${value}px`;
};

export const resizeWallpaperWrapper = () => {
  const { rootBodyElement, activeArtboard, sessionId, canAccessIframe } = store.getState(); // eslint-disable-line no-undef
  if (canAccessIframe) {
    const thisWindow = window; // eslint-disable-line no-undef
    const iframeParent = thisWindow.frameElement.parentNode;
    const wallpaperFrame = iframeParent.ownerDocument.getElementById(`ivoBackgroundrFrame-${sessionId}`);
    const wrapperScale = rootBodyElement.getBoundingClientRect().width / 1000;
    const offsetHeight = activeArtboard.offsetHeight;
    wallpaperFrame.style.width = `${activeArtboard.viewport.width * wrapperScale}px`;
    wallpaperFrame.style.height = `${activeArtboard.viewport.height * wrapperScale}px`;
    setWallpaperSpacing(offsetHeight * wrapperScale);
    const tl = parseInt(rootBodyElement.getAttribute('data-ivo-tl'), 10) || 0;
    rootBodyElement.setAttribute('data-ivo-active', activeArtboard.name);
    if (tl !== 0) rootBodyElement.setAttribute('data-ivo-tl', tl * wrapperScale);
  }
};

export const resizePreviewWallpaperWrapper = () => {
  const { rootBodyElement, activeArtboard, canAccessIframe } = store.getState(); // eslint-disable-line no-undef
  if (canAccessIframe) {
    const thisWindow = window; // eslint-disable-line no-undef
    const iframeParent = thisWindow.frameElement.parentNode;
    const previewBackground = window.top.document.querySelector('.site-background');
    const wrapperScale = previewBackground.getBoundingClientRect().width / 1000;
    const offsetHeight = activeArtboard.offsetHeight;
    iframeParent.style.width = `${activeArtboard.viewport.width * wrapperScale}px`;
    iframeParent.style.height = `${activeArtboard.viewport.height * wrapperScale}px`;
    previewBackground.style.backgroundColor = 'transparent';
    previewBackground.style.zIndex = '0';
    previewBackground.firstChild.style.marginTop = `${offsetHeight * wrapperScale}px`;
  }
};

export const moveWallpaperContainer = () => {
  const { sessionId, rootBodyElement } = store.getState();
  const thisWindow = window; // eslint-disable-line no-undef
  const iframeParent = thisWindow.frameElement.parentNode;
  const wallpaperContainer = iframeParent.ownerDocument.getElementById(`ivoWallpaperContainer-${sessionId}`);
  const rootBodyElementMargin = rootBodyElement ? parseFloat(window.getComputedStyle(rootBodyElement).marginTop) : 0;
  const rootBodyElementOffset = parseInt(rootBodyElement.getAttribute('data-ivo-to'), 10) || 0;
  const topPosition = (rootBodyElement.getBoundingClientRect().top + rootBodyElementOffset) - rootBodyElementMargin;
  const topLimit = parseInt(rootBodyElement.getAttribute('data-ivo-tl'), 10) || 0;
  if (topPosition <= topLimit) {
    wallpaperContainer.style.top = `${topLimit}px`;
    return;
  }
  wallpaperContainer.style.top = `${topPosition}px`;
};

export const createWallpaperContainer = (tagInformation, placementId, rootElementName, canAccessIframe, rootBodyElement) => {
  const rootDocument = canAccessIframe ? window.top.document : document;
  const rootBodyElementTopPosition = parseInt(rootBodyElement.getAttribute('data-ivo-ts'), 10) || 0;
  const zIndex = parseInt(rootBodyElement.getAttribute('data-ivo-sd'), 10) || 0;
  const anchorElement = rootBodyElement.getAttribute('data-ivo-anchor') || null;
  const anchor = anchorElement ? rootDocument.querySelector(anchorElement) : rootDocument.body;
  const topLimit = parseInt(rootBodyElement.getAttribute('data-ivo-tl'), 10) || 0;
  if (canAccessIframe) collapseIframe();
  try {
    const wallpaperContainer = document.createElement('div'); // eslint-disable-line no-undef
    wallpaperContainer.id = `ivoWallpaperContainer-${tagInformation.sessionId}`;
    wallpaperContainer.className = 'ivo-ad skin single root';
    wallpaperContainer.style.cssText = `position: absolute;  margin-top:${rootBodyElementTopPosition}px; top: 0; left: 0; width: 100%; height: calc(100% - ${rootBodyElementTopPosition}px); z-index: ${zIndex};`;

    const wallpaperWrapper = document.createElement('div'); // eslint-disable-line no-undef
    wallpaperWrapper.id = `ivoWallpaperWrapper-${tagInformation.sessionId}`;
    wallpaperWrapper.style.cssText = `position: sticky; top:${topLimit}px; width: auto; height: 100vh; overflow: hidden; margin: 0; padding: 0;`;

    wallpaperContainer.appendChild(wallpaperWrapper);

    const iframe = document.createElement('iframe'); // eslint-disable-line no-undef
    iframe.id = `ivoBackgroundrFrame-${tagInformation.sessionId}`;
    iframe.style.cssText = 'position: absolute; left: 50%; transform: translateX(-50%); border: 0;';
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.scrolling = 'no';

    wallpaperWrapper.appendChild(iframe);
    anchor.insertBefore(wallpaperContainer, anchor.firstChild);
    rootDocument.body.style.cssText += 'position: relative; overflow: unset;';

    return iframe;
  } catch (e) {
    console.log('ivo : error rendering skins container');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/wallpaperContainer.js